export default __webpack_public_path__ + "static/media/helpdeskIcon.2e0198df.svg";